import React from 'react';
import type { Page, Component } from '../ComponentEditModal.types';

interface BodyEndData {
  inlineScripts?: string;
  rawBodyEndHtml?: string;
  noscriptContent?: string;
}

interface BodyEndEditorProps {
  formData: BodyEndData;
  setFormData: (data: BodyEndData) => void;
  pages: Page[];
  isLoadingPages: boolean;
  currentPageComponents?: Component[];
}

export const BodyEndEditor: React.FC<BodyEndEditorProps> = ({ formData, setFormData }) => {
  const data = formData;

  return (
    <div className="space-y-8">
      {/* Scripts Section */}
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-4">Scripts</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Inline Scripts</label>
            <textarea
              value={data.inlineScripts || ''}
              onChange={e => setFormData({ ...data, inlineScripts: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 font-mono text-sm"
              rows={6}
              placeholder="console.log('Hello World');"
            />
            <p className="mt-1 text-xs text-gray-500">
              JavaScript code to run at the end of the page. Do not include &lt;script&gt; tags.
            </p>
          </div>
        </div>
      </div>

      {/* Custom HTML Section */}
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-4">Custom HTML</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Body End HTML</label>
            <textarea
              value={data.rawBodyEndHtml || ''}
              onChange={e => setFormData({ ...data, rawBodyEndHtml: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 font-mono text-sm"
              rows={6}
              placeholder="<div id='custom-widget'></div>"
            />
            <p className="mt-1 text-xs text-gray-500">
              Add custom HTML before the closing &lt;/body&gt; tag. Use with caution.
            </p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Noscript Content</label>
            <textarea
              value={data.noscriptContent || ''}
              onChange={e => setFormData({ ...data, noscriptContent: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 font-mono text-sm"
              rows={3}
              placeholder="<p>Please enable JavaScript to view this site.</p>"
            />
            <p className="mt-1 text-xs text-gray-500">Content shown when JavaScript is disabled.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
